__turbopack_context__.v({
  "issueChartButtonsContainer": "HeaderChart-module-scss-module__1X28yW__issueChartButtonsContainer",
  "issueChartHeaderMultiRowContainer": "HeaderChart-module-scss-module__1X28yW__issueChartHeaderMultiRowContainer",
  "issueChartTitle": "HeaderChart-module-scss-module__1X28yW__issueChartTitle",
});
